const firestoreModule = require('firebase').firestore;
export default firestoreModule;
